import hljs from "highlight.js/lib"
global.ApiDoc = require('./api').ApiDoc;
global.ApiExplorerClient = require('./api.explorer.client').ApiExplorerClient;

// import StickyApiSideBar from "../StickyApiSideBar";
//
// new StickyApiSideBar;
// // new StickyApiSideBar({
// //     selectorPrefix: '.rest-api '
// // });

//scroll to id
let apiSidebarMenuLinks = $(".stixty-content a, .rest-api__content a");
apiSidebarMenuLinks.click(function(e){
    apiSidebarMenuLinks.removeClass('active');
    $(this).addClass('active');
    let section = $('[id="'+ $(this).attr('href').replace('#', '') +'"]');
    let menuHeight = $(".header--settings-block").outerHeight();
    let distance = ($(section).offset().top - menuHeight) - 15;
    $("html, body").animate({scrollTop: distance}, 1000);
});


hljs.initHighlightingOnLoad();

function initNestedTabs( $element ) {
    if( $($element).length){
        let $tabSwitchItem = $('.ui-tab-switch .ui-switch-item');
        let $tabBody;

        $tabSwitchItem.on("click", function (e) {
            e.preventDefault();
            let $headerItemsList = $(this).parents('.nested-tab-switcher--header');
            $($headerItemsList).find('.ui-switch-item').removeClass('active');
            $(this).addClass('active');
            var $tab_name = $(this).data('tab');
            //console.log('tab name = ' + $tab_name);

            $tabBody = $(this).closest('.nested-code-tabs').find('.wrap-tabs .nested-tab--item');
            $tabBody.removeClass('active');

            if( $( $tabBody ).hasClass($tab_name)){
                $tabBody.filter('.' + $tab_name).addClass('active');
            }
        });
    }
}

initNestedTabs( $('.nested-code-tabs') );